import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const PAGES = [
  { key: "home", label: "Home" },
  { key: "shop", label: "Shop" },
  { key: "about", label: "About" },
  { key: "blog", label: "Journal" },
  { key: "contact", label: "Contact" },
];

const AdminSeo = () => {
  const [selected, setSelected] = useState("home");
  const [data, setData] = useState(null);

  useEffect(() => { api.get(`/seo/${selected}`).then(r => setData(r.data)).catch(() => {}); }, [selected]);

  const save = async () => {
    try {
      await api.put(`/admin/seo/${selected}`, data);
      toast.success("SEO saved");
    } catch { toast.error("Save failed"); }
  };

  return (
    <div data-testid="admin-seo-page">
      <p className="eyebrow mb-1">Visibility</p>
      <h1 className="font-hero text-3xl mb-6">SEO manager</h1>
      <div className="flex gap-2 mb-6 flex-wrap">
        {PAGES.map(p => (
          <button
            key={p.key}
            onClick={() => setSelected(p.key)}
            className={`px-5 py-2 rounded-full font-label text-[11px] uppercase tracking-[0.22em] transition ${selected === p.key ? "bg-charcoal text-cream" : "bg-white border border-border"}`}
          >{p.label}</button>
        ))}
      </div>
      {data && (
        <div className="bg-white rounded-2xl border border-border p-6 space-y-4 max-w-2xl">
          <div><label className="eyebrow">Title</label><Input value={data.title || ""} onChange={e => setData({ ...data, title: e.target.value })} data-testid="seo-title-input" /></div>
          <div><label className="eyebrow">Meta description</label><Textarea rows={3} value={data.description || ""} onChange={e => setData({ ...data, description: e.target.value })} data-testid="seo-description-input" /></div>
          <div><label className="eyebrow">Keywords</label><Input value={data.keywords || ""} onChange={e => setData({ ...data, keywords: e.target.value })} data-testid="seo-keywords-input" /></div>
          <div><label className="eyebrow">Open Graph image URL</label><Input value={data.og_image || ""} onChange={e => setData({ ...data, og_image: e.target.value })} data-testid="seo-ogimage-input" /></div>
          <div><label className="eyebrow">Canonical URL</label><Input value={data.canonical_url || ""} onChange={e => setData({ ...data, canonical_url: e.target.value })} data-testid="seo-canonical-input" /></div>
          <div>
            <label className="eyebrow">Search engine indexing</label>
            <div className="flex flex-wrap gap-2 mt-1" data-testid="seo-robots">
              {[
                { v: "index,follow", l: "Index & Follow" },
                { v: "noindex,nofollow", l: "Hide (noindex,nofollow)" },
                { v: "noindex,follow", l: "Noindex (follow links)" },
              ].map((opt) => {
                const active = (data.seo_robots || "index,follow") === opt.v;
                return (
                  <button
                    type="button"
                    key={opt.v}
                    onClick={() => setData({ ...data, seo_robots: opt.v })}
                    className={`text-xs px-3 py-2 rounded-full border transition ${active ? "border-rose bg-rose/10 text-rose" : "border-border text-charcoal/70 hover:border-rose/50"}`}
                    data-testid={`seo-robots-${opt.v.split(',')[0]}`}
                  >
                    {opt.l}
                  </button>
                );
              })}
            </div>
          </div>
          <button className="btn-primary" onClick={save} data-testid="seo-save-button">Save changes</button>
        </div>
      )}
    </div>
  );
};

export default AdminSeo;
